import {
  ChangeDetectionStrategy,
  Component,
  input,
} from '@angular/core';
import { IconName } from './icon-name';

/**
 * Papercast icon. References a <symbol> from the sprite that IconRegistry
 * injects at app start (see icon-registry.ts). The glyph paints with
 * `currentColor`, so set the CSS `color` (or a text-* utility) on a parent.
 *
 *   <app-icon name="icon-search" [size]="20" />
 *
 * Icon names are the sprite symbol ids — the kebab-case .svg filenames under
 * src/assets/icons/. The IconName union is generated from that folder.
 */
@Component({
  selector: 'app-icon',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <svg
      [attr.width]="size()"
      [attr.height]="size()"
      aria-hidden="true"
      focusable="false"
    >
      <use [attr.href]="'#' + name()"></use>
    </svg>
  `,
  styles: `
    :host {
      display: inline-flex;
      line-height: 0;
    }
  `,
})
export class Icon {
  readonly name = input.required<IconName>();
  readonly size = input(24);
}
